import Chip from './chip';
import EntityHelper from '../helpers/entity';
import MachineCountType from './machineCountType';

export default class Machine {
  constructor(data) {
    EntityHelper.validateData(data);
    const {
      // eslint-disable-next-line camelcase
      id, name, machine_id, machine_name, machine_count_type, countTypeExpand, factory,
    } = data;

    // eslint-disable-next-line camelcase
    this.id = EntityHelper.setId(machine_id || id);
    // eslint-disable-next-line camelcase
    this.name = machine_name || name;
    // eslint-disable-next-line camelcase
    this.countTypeExpand = machine_count_type || countTypeExpand;
    this.factory = factory ?? null;
  }

  asChip() {
    return new Chip({
      id: this.id, title: this.name, color: 'blue', type: Machine,
    });
  }

  countType() {
    return new MachineCountType(this.countTypeExpand);
  }
}
